import { OUTCOME_PROVIDER_BLACK_LIST } from 'modules/SlotsRoot/providersData/Outcome/constants'
import { Providers } from 'modules/SlotsRoot/types/configuration'
import {
  IFreeSpinInfoResponse,
  IFreeSpinInfoView,
  IOutcomeServerGame,
  IOutcomeSessionResponse,
} from 'modules/SlotsRoot/types/interfaces/Slots/Outcome'
import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

import { IConvertGameList, ISlotConverter } from '../../types/converter'
import { getSlotImage } from '../../utils/outcome'
import { blackListGames, getTab, getTabLive } from './OutcomeUtils'

class OutcomeConverter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IOutcomeServerGame[]>): ISlotViewItem[] =>
    data
      .map((item: IOutcomeServerGame) => ({
        id: item.Id,
        gameId: item.Id,
        description: item.Description,
        format: item.Format,
        gameName: item.Name,
        tab: getTab(item.Id),
        tabLive: getTabLive(item.Id),
        provider: item.SectionId !== 'pragmatic' ? item.SectionId : 'pragmaticplay',
        imageUrl: getSlotImage(item.Id, item.SectionId),
        routeProvider: Providers.otc,
        hasDemoMode: true,
        hasFreeSpins: item.HasFreeSpins,
      }))
      .filter(
        item => !OUTCOME_PROVIDER_BLACK_LIST.includes(item.provider) && blackListGames.indexOf(item.gameId) === -1,
      )

  convertGameUrl = ({ data }: IOutcomeSessionResponse) => data.session_url

  convertFreeSpinInfo = (data: IFreeSpinInfoResponse): IFreeSpinInfoView => ({
    provider: data.provider,
    sessionEnd: data.session_end,
    freeSpinLeft: data.freespin_left,
    prizeAmount: data.prize.amount,
    prizeCurrency: data.prize.currency,
  })
}

export default OutcomeConverter
